<template>
  <page-option
    disable-add
    overflow-hidden
    titleIcon="mdi-city"
    title="Quản lý Tỉnh / Thành phố"
  >
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        :disableCreate="true"
        placeholder="Tìm kiếm theo mã, tên tỉnh..."
      >
        <template #extra-btn>
          <div class="pl-2">
            <v-btn color="primary" depressed @click="openImportDialog">
              <v-icon left>mdi-folder-zip-outline</v-icon>
              Cập nhật từ file Zip (GDB)
            </v-btn>
          </div>
        </template>
      </FilterSearch>
    </template>

    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params.sync="params"
        :defaultParams="default_params"
        sync-params
      >
        <!-- STT Column -->
        <template v-slot:[`item.index`]="{ index }">
          <span>{{ index + 1 }}</span>
        </template>

        <!-- Mã ĐVHC Column -->
        <template v-slot:[`item.maDonViHanhChinh`]="{ item }">
          <v-chip
            v-if="item.maDonViHanhChinh"
            small
            label
            color="primary"
            outlined
            class="font-weight-medium"
          >
            {{ item.maDonViHanhChinh }}
          </v-chip>
          <span v-else class="text--disabled">—</span>
        </template>

        <!-- Tên tỉnh/TP Column -->
        <template v-slot:[`item.ten`]="{ item }">
          <span class="font-weight-medium">{{ item.ten }}</span>
        </template>

        <!-- Diện tích Column -->
        <template v-slot:[`item.dienTich`]="{ item }">
          <span v-if="item.dienTich">{{ Number(item.dienTich).toLocaleString('vi-VN') }} ha</span>
          <span v-else class="text--disabled">—</span>
        </template>

        <!-- Ngày tạo Column -->
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>

        <!-- Ngày cập nhật Column -->
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
      </base-serve-table>
    </v-sheet>

    <!-- Import Zip (GDB) Dialog -->
    <ProvinceDialogImport
      ref="importDialog"
      @success="onImportSuccess"
    />
  </page-option>
</template>

<script>
import { API_PROVINCE } from '@api'
import FilterSearch from '@src/layout/filter-search.vue'
import ProvinceDialogImport from './province-dialog-import.vue'

export default {
  name: 'ProvinceManager',
  components: {
    FilterSearch,
    ProvinceDialogImport,
  },
  data: () => ({
    api: API_PROVINCE,
    default_params: {},
    params: { search: '' },
    headers: [
      {
        text: 'STT',
        value: 'index',
        sortable: false,
        width: '70px',
        align: 'center',
      },
      {
        text: 'Mã ĐVHC',
        value: 'maDonViHanhChinh',
        sortable: true,
        width: '130px',
        align: 'center',
      },
      {
        text: 'Tên Tỉnh / Thành phố',
        value: 'ten',
        sortable: true,
        align: 'start',
      },
      {
        text: 'Diện tích (ha)',
        value: 'dienTich',
        sortable: true,
        width: '180px',
        align: 'end',
      },
      {
        text: 'Ngày cập nhật',
        value: 'updated_at',
        sortable: true,
        width: '180px',
        align: 'center',
      },
    ],
  }),
  methods: {
    openImportDialog() {
      if (this.$refs.importDialog) {
        this.$refs.importDialog.open()
      }
    },
    onImportSuccess() {
      if (this.$refs.table) {
        this.$refs.table.reload({ forceToPage1: true })
      }
    },
  },
}
</script>

